export default {
  contact_title: 'Write to us',
  contact_text: 'KIT team will answer all your questions',
  contact_send: 'Send',
  contact_name: 'Name',
  contact_email: 'E-mail',
  contact_theme: 'Letter subject',
  contact_message: 'Message',
  contact_send_error: 'Something seems to have gone wrong. Your message could not be sent. Please try again later.',
  contact_email_invalid: 'Invalid email format',
  contact_empty_field: 'Required field',
  contact_success: 'Your message has been sent successfully'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/contracts.js